<template>
  <div class="section-wrapper">
    <template v-if="!ctaReady">
      <div class="alert alert-warning">
        <span>
          {{ $t("cta.labels.loading") }}
        </span>
      </div>
    </template>
    <template v-else>
      <div class="row" v-if="showLink">
        <volcan-input-checkbox
          v-model="ctaLocal.isActiveCampaignUnilingual"
          :text="$t('cta.labels.isActiveCampaign')"
          class="col-12"
        />
      </div>
      <!-- <div class="row" v-if="!isActiveCampaignUnilingual">
        <volcan-input-text
          v-model="ctaLocal.activeCampaignId"
          :text="$t('cta.labels.activeCampaignId')"
          class="col-12"
        />
      </div> -->
      <div class="row">
        <volcan-input-text
          v-model="getRes(ctaLocal).name"
          :text="$t('cta.labels.name')"
          class="col-12"
        />
      </div>
      <div class="row" v-if="showActiveCampaingComputed">
        <volcan-input-textarea
          v-model="getRes(ctaLocal).activeCampaignId"
          :text="$t('cta.labels.activeCampaignId')"
          class="col-12"
          :rows="2"
        />
      </div>
      <div class="row" v-if="showLinkComputed">
        <volcan-input-text
          v-model="getRes(ctaLocal).link"
          :text="$t('cta.labels.link')"
          class="col-12"
        />
      </div>
    </template>
  </div>
</template>
<script>
import en from "./admin-en.json";
import fr from "./admin-fr.json";
import helpers from "@mixins/helpers.js";
export default {
  name: "volcan-cta",
  mixins: [helpers],
  beforeMount() {
    this.$i18n.add("fr", fr);
    this.$i18n.add("en", en);
  },
  data: function() {
    return {
      tabs: {
        languageIdActive: 0
      }
    };
  },
  props: {
    cta: { type: Object },
    languageIdActive: { type: Number },
    showLink: { type: Boolean, default: true }
  },
  model: {
    prop: "cta",
    event: "cta:change"
  },
  mounted() {
    this.tabs.languageIdActive = this.languageIdActive;
  },
  watch: {
    languageIdActive: function(val) {
      this.tabs.languageIdActive = val;
    }
  },
  computed: {
    ctaLocal: {
      get: function() {
        return this.cta;
      },
      set: function(value) {
        this.$emit("cta:change", value);
      }
    },
    ctaReady() {
      return this.ctaLocal && this.getRes(this.ctaLocal);
    },
    showLinkComputed() {
      return this.showLink && !this.ctaLocal.isActiveCampaignUnilingual;
    },
    showActiveCampaingComputed() {
      return this.ctaLocal.isActiveCampaignUnilingual || !this.showLink;
    }
  },
  methods: {}
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// components/Custom/Cta/cta.vue